<template>
  <div class="row pt-2">
    <div class="col">
      <div v-if="isSauvegardeEnCours">
        <vue-loaders  name="ball-beat" class = "justify-center"></vue-loaders>
      </div>
      <div v-else>
        <Button label="Sauvegarder" v-on:click="sauvegarder" />
      </div>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonBar',
  emits: ['sauvegarder', 'fermer'],
  props: ['isSauvegardeEnCours'],
  methods: {
    sauvegarder() {      
      this.$emit('sauvegarder');
    },
    fermer() {
      this.$emit('fermer');
    },
  }
}
</script>